import { render, staticRenderFns } from "./pictureList.vue?vue&type=template&id=28a1bab9&scoped=true&"
import script from "./pictureList.vue?vue&type=script&lang=js&"
export * from "./pictureList.vue?vue&type=script&lang=js&"
import style0 from "./pictureList.vue?vue&type=style&index=0&id=28a1bab9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a1bab9",
  null
  
)

export default component.exports